<template>
  <div class="product">
    <div class="product__image skeleton"></div>
    <div class="product__info">
      <span class="product__title skeleton"></span>
      <span class="product__price skeleton"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkeletonProductCard",
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/skeleton";

.product {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.product__image {
  aspect-ratio: 4/5;
}

.product__info {
  padding: 8px 0;
}

.product__title {
  display: block;
  height: 20px;
  width: 50%;
}

.product__price {
  display: block;
  height: 20px;
  width: 10%;
  margin-top: 4px;
}
</style>
